import { combineReducers } from "redux";
import CommonReducer from "./CommonReducer";
import ResDataReducer from "./ResDataReducer";

export default combineReducers({
    CommonReducer,ResDataReducer
});
